import React from 'react'
import { useSelector } from 'react-redux'
import { setShowLogin, setShowPopUp } from '../../../redux/auth/actions'

import Overlay from '../../Overlay'
import Button from 'antd/lib/button'

const styles = {
    container: {
        width: 465,
        maxHeight: '85vh',
        overflow: 'auto',
        padding: '1em',
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '0.64em'
    },
    body: {
        marginTop: '0.64em'
    },
    footer: {
        textAlign: 'center',
        marginTop: '2em',
    },
}


const EmailExist = () => {

    const visible = useSelector(state => state.auth.showPopUp)

    const onButtonClick = () => {
        setShowPopUp(false)
        setShowLogin(true)
    }

    return (
        <Overlay
            onClose={() => setShowPopUp(false)}
            visible={visible}
            closebutton={false}
            minimal={true}
            background={'#FFF'}
        >
            <div style={styles.container}>

                <div style={styles.body}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontSize: 18, fontWeight: 600, textAlign: 'center' }}>
                            This email address exists in the system.
                        </span>
                        <div style={{ marginTop: '1em', marginBottom: '1em', display: 'flex', flexDirection: 'column', }}>
                            <span style={{ fontSize: 16, fontWeight: 600 }}>
                                FIRST-TIME USER:
                            </span>
                            <span>
                            
                                Check your inbox for an email from <a href="mailto:system@bssnet.com">system@bssnet.com</a> containing
                                a temporary password (valid for 14 days). <i>Your email has likely already been added to the system by an administrator.</i>
                            </span>
                        </div>

                        <div style={{ fontSize: 16, fontWeight: 600, margin: 'auto' }}>
                            OR
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '1em' }}>
                            <span style={{ fontSize: 16, fontWeight: 600 }}>RETURNING USER:</span>
                            <span>If you are trying to also register for an additional location, login first
                                with your existing password to complete the registration process for
                                the new location.
                            </span>
                        </div>
                    </div>

                    <div style={styles.footer}>
                        <Button type='primary' onClick={onButtonClick}>Continue To Login</Button>
                    </div>
                </div>
            </div>
        </Overlay>
    )
}

export default EmailExist
